// State centroid table for the 7 priority states.
// Values copied exactly from map-utils.ts STATE_CENTERS — do NOT import from map-utils.ts
// (that table is private; this helper owns its own copy per the RULE-276 fence).
const STATE_CENTROIDS: Record<string, { lat: number; lng: number }> = {
  WI: { lat: 44.5, lng: -89.5 },
  MN: { lat: 46.0, lng: -94.5 },
  MI: { lat: 44.3, lng: -85.6 },
  IL: { lat: 40.0, lng: -89.0 },
  PA: { lat: 41.0, lng: -77.5 },
  IA: { lat: 42.0, lng: -93.5 },
  OH: { lat: 40.4, lng: -82.7 },
};

/**
 * Returns the map centroid for a covered home state, or `undefined` for
 * empty, undefined, or unmapped state values.
 *
 * Input is normalized with `.trim().toUpperCase()` so 'wi', ' WI ', etc.
 * all resolve to the WI centroid.
 */
export function homeStateCenter(
  state: string | undefined,
): { lat: number; lng: number } | undefined {
  if (!state) return undefined;
  const normalized = state.trim().toUpperCase();
  if (!normalized) return undefined;
  return STATE_CENTROIDS[normalized];
}
